const COMMON_CLIENT_ID = "6f4118cd-98da-43ca-9a38-325f60732054";
const COMMON_TENANT_ID = "806ff6b2-e0d0-4dbe-9de0-f7c1df905ba4";
export const environment = {
  production: false,
  keplerServerURL: "https://titan.dev-keplerbe.kairhos.com",
  surveyServerURL: "https://survey.dev.kairhos.com/",
  airoUrl: "https://dev.airobe.kairhos.com/api",
  airoFrontendURL: "https://dev.airo.kairhos.com",
  injestIQURL: "https://dev-injest.iq.kairhos.com/",
  airoDataUrl: "https://dev.airo-databe.kairhos.com/api",
  
  tenant_info: {
    kepler: {
      CLIENT_ID: "d5948759-0c28-4d4a-850c-44251b99b300",
      TENANT_ID: "fbfcf739-7deb-4829-b8b1-797a7b1727a1",
    },
    beta: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    alpha: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    titan: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    vastu: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    gama: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    demo: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    www: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    rc: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
    credila: {
      CLIENT_ID: COMMON_CLIENT_ID,
      TENANT_ID: COMMON_TENANT_ID,
    },
  },
};
